class CopyrightController {
}

const copyrightControllerComponentDefinition = {
    controller: [CopyrightController],
    template: require('./copyright.component.html').trim(),
};

module.exports = {
    CopyrightController,
    copyrightControllerComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/common/copyright/copyright.component.js